
export const activities = {
    actionButtonsInMultiMatrix: {
        default: ['previousActivityInMulti', 'nextActivityInMulti']
    },
    activitiesDisplayedColumns: ['title', 'educationalLevel', 'chapters', 'action'],
    activityOptionsEditable: ['content'], // options for new lesson editor when user want to edit activities exp content, titleAndInstruction, all
    activitiesWithDefinedTypology: ['EXT'], // type of activities used for filter in editor-activities-list
    activateNewEditor: true,
    allowErrorReporting: false,
    cardFieldsForPreview: [ 'chapters', 'description'],
    cardLayout: 'card-split-media-info',
    displayFilters: false,
    hideAddButtonLessonList: true,
    hideUserActionButtons: true,
    hiddenActivityPreview: false,
    isAddLessonCardNewStyle: true,
    isArrowNavigationEnabled: ['trainer', 'manager', 'director', 'administrator'],  // allow arrow for navigation in lesson (player)
    isOnlyModelLesson: true, // should be called by example : enableSelectionByTab for lesson list component
    isTtsEnabled: false,
    isLessonArchiveEnabled: {default: false, manager: true, administrator: true},
    isLessonUnarchiveEnabled: {default: false, manager: true, administrator: true},
    isLessonPublishEnabled: {default: false, manager: true, administrator: true},
    isLessonEditionEnabled: {default: false, trainer: true, manager: true, administrator: true},
    isLessonDeleteEnabled: {default: false, manager: true, administrator: true},
    displayLessonState: true,
    latexKeyboard: false,
    lessonDialogFields: {
        default: ['title', 'description', 'educationalLevel', 'assignation_type'],
    },
    lessonPageActions: {
        lesson: {
            manager: [
                'editAndDeleteAssignments',
                'deleteWithAssignments',
                'duplicate',
                'duplicateAndEdit'
            ],
            default: [
                'editAndDeleteAssignments',
                'deleteWithAssignments',
                'assign',
                'duplicateAndEdit'
            ]
        },
        model: {
            manager: [
                'editAndDeleteAssignments',
                'deleteWithAssignments',
                'duplicate',
                'duplicateAndEdit'
            ],
            default: [
                'assign',
                'duplicateAndEdit'
            ]
        }
    },
    lessonStep: null,
    menuLessonsDeployable: {default: ['onlyModels','userLessons']},
    openDialogInfoAfterDuplicateLesson: {
        manager: false,
        default: true
    },
    numberOfTryBeforeDisplayCorrection: 3,
    routeOnExitLesson: ['lessons', 'list', 'lessons'],
    searchFields: {
        default: {
            default: ['educationnalLevel', 'concepts', 'thematics', 'skills', 'title', 'bookmarks', 'launchSearch', 'countEntities'],
        },
    },
    showLessonTitle: false,
    stepper: null,
    useSummaryPageInsteadOfRecap: true,
    allowedRolesForModelsAssignation: ['manager', 'trainer'],
    allowedActivityTypes: [],
    iframeParams: ['uid', 'prenom', 'codeclasse', 'token', 'assignationId'],
    // required params name for partner through iframe url
    dynamicContent: false,
    menu: {
        models: false
    },
    multiSelectSearchFields: ['educationnalLevel', 'assignation_type'],
    filtersEditorActivitiesList: ['title', 'educationnalLevel', 'chapters'],
    lessonDialogRequiredFields:  {
        default: ['title', 'educationalLevel', 'assignation_type'],
    },
    saveLessonContentOptions: {
        activityTypesCanBeDuplicate: [], // type d'activitiés que l'on peut dupliquer (certaines activitiés n'ont pas besoin d'être dupliqué)
        saveContent: false // si chaque activités ou souslesson du parcours doit être sauvegardé
    },
    typeActivitiesToSkip: [], // (lesson player) skip activity if activity's type is included,
    displayLearnerInfo: false,
    recommendationDisplayedColumns: ['checkbox', 'pseudo', 'lesson', 'level', 'type', 'buttons'], // 'confidence', retrait en attendant que ça soit opérationnel
    showAddLessonButtonCard: true,
    showBookmarkButton: false,
    shouldSetDefaultOptionsOnActivityList: true,
    accessMatrix: {
        activitiesListing: {
            view: ['trainer', 'manager', 'administrator'],
        },
        lessonsListing: {
            view: ['trainer', 'manager', 'administrator'],
        }
    },
    useNicknameInsteadOfUsername: true,
    initialiseIframeUrl: true,
    useDynamicThumbmailInRegardOfAssignationTypeAndLevel : true,
    showInfoToTeacherAfterAssignment: true,
    buttons: {
        player: {
            auto: [
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
            preview: [
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            }
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
            training: [
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            },
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
            homework: [
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            },
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
        },
    },
    feedbackButtons: [
        {
            title: 'generic.restart',
            type: 'reset',
            classCss: ['btn-option'],
            svgIcon: 'restart-alt-rounded',
            display: true,
            options: {
                MULTI: {
                    display: {
                        case: 'force',
                        value: false
                    },
                },
            },
        },
    ],
    autoCorrection: true,
    noHeaderBarOnActivity: true,
    openFilterByDefaultOnLessonPage: true,
    useSeeMoreExpandButton: false,
};
